/* ==========================================================================
   Moonou Product Details — Tab switching with sliding indicator & scroll fades
   Indicator uses CSS custom properties on .moonou-pd__nav (::before pseudo)
   ========================================================================== */
(function () {
  'use strict';

  // Modul-globaler Handler-Slot fuer moonou:mode-change (siehe initSection unten):
  // shopify:section:load ersetzt beim Editor-Reload das komplette Section-Element,
  // daher ist section._moonouPdModeHandler in initSection dann immer leer und
  // ein section-gebundener Guard greift nicht. Der Handler wird deshalb hier
  // modul-global gehalten, damit er vor jeder Neuregistrierung entfernt werden kann.
  var moonouPdModeHandler = null;

  function initSection(section) {
    var wrap = section.querySelector('.moonou-pd__nav-wrap');
    if (!wrap) return;

    var scrollEl = wrap.querySelector('.moonou-pd__nav-scroll');
    var nav = wrap.querySelector('.moonou-pd__nav');
    var pills = nav.querySelectorAll('.moonou-pd__pill');
    var panelsEl = section.querySelector('.moonou-pd__panels');
    var panels = section.querySelectorAll('.moonou-pd__panel');
    var images = section.querySelectorAll('.moonou-pd__img');
    var fadeLeft = wrap.querySelector('.moonou-pd__fade--left');
    var fadeRight = wrap.querySelector('.moonou-pd__fade--right');

    if (pills.length === 0) return;

    // Position indicator via CSS custom properties on nav (drives ::before)
    function positionIndicator(pill, animate) {
      if (!animate) {
        nav.classList.add('moonou-pd__nav--no-transition');
      }
      nav.style.setProperty('--ind-left', pill.offsetLeft + 'px');
      nav.style.setProperty('--ind-width', pill.offsetWidth + 'px');
      nav.style.setProperty('--ind-height', pill.offsetHeight + 'px');
      if (!animate) {
        nav.offsetHeight; // force reflow
        nav.classList.remove('moonou-pd__nav--no-transition');
      }
    }

    // Show/hide gradient fades based on scroll position (uses inline opacity)
    function updateFades() {
      if (!fadeLeft || !fadeRight) return;
      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      if (maxScroll <= 2) {
        fadeLeft.style.opacity = '0';
        fadeRight.style.opacity = '0';
        return;
      }
      fadeLeft.style.opacity = scrollEl.scrollLeft > 2 ? '1' : '0';
      fadeRight.style.opacity = scrollEl.scrollLeft < maxScroll - 2 ? '1' : '0';
    }

    // Listen for scroll to update fades
    scrollEl.addEventListener('scroll', updateFades, { passive: true });

    // Find the initially active pill (or default to first)
    var activePill = nav.querySelector('.moonou-pd__pill[data-active="true"]') || pills[0];
    if (activePill && !activePill.hasAttribute('data-active')) {
      activePill.setAttribute('data-active', 'true');
    }

    // Initialize indicator + fades after layout
    requestAnimationFrame(function () {
      positionIndicator(activePill, false);
      updateFades();
    });

    // Fallback: recalculate after full page load (CSS/images/fonts ready)
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function onLoad() {
        positionIndicator(
          nav.querySelector('.moonou-pd__pill[data-active="true"]') || pills[0],
          false
        );
        updateFades();
        window.removeEventListener('load', onLoad);
      });
    }

    // Click handler for pill tabs
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (this.getAttribute('data-active') === 'true') return;

        var targetIndex = parseInt(this.getAttribute('data-tab-index'), 10);

        // Update pill active states
        pills.forEach(function (p) {
          p.setAttribute('data-active', 'false');
        });
        this.setAttribute('data-active', 'true');

        // Slide indicator to clicked pill
        positionIndicator(this, true);

        // Scroll clicked pill into center of nav (without scrolling the page)
        var targetScroll = this.offsetLeft - (scrollEl.clientWidth / 2) + (this.offsetWidth / 2);
        scrollEl.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });

        // Animate panels height transition
        var currentHeight = panelsEl.offsetHeight;
        panelsEl.style.height = currentHeight + 'px';

        // Switch panels with animation
        panels.forEach(function (panel, i) {
          if (i === targetIndex) {
            panel.hidden = false;
            panel.classList.remove('moonou-pd__panel--entering');
            panel.offsetHeight; // force reflow
            panel.classList.add('moonou-pd__panel--entering');
          } else {
            panel.hidden = true;
            panel.classList.remove('moonou-pd__panel--entering');
          }
        });

        // Measure new height and animate to it
        panelsEl.style.height = 'auto';
        var newHeight = panelsEl.offsetHeight;
        panelsEl.style.height = currentHeight + 'px';
        panelsEl.offsetHeight; // force reflow
        panelsEl.style.height = newHeight + 'px';

        // Cleanup after height transition
        function onTransitionEnd(e) {
          if (e.propertyName !== 'height') return;
          panelsEl.style.height = '';
          panelsEl.removeEventListener('transitionend', onTransitionEnd);
        }
        panelsEl.addEventListener('transitionend', onTransitionEnd);

        // Crossfade images
        images.forEach(function (img, i) {
          img.setAttribute('data-active', i === targetIndex ? 'true' : 'false');
        });
      });
    });

    // Recalculate indicator and fades on resize
    var resizeObserver = new ResizeObserver(function () {
      var current = nav.querySelector('.moonou-pd__pill[data-active="true"]');
      if (current) {
        positionIndicator(current, false);
      }
      updateFades();
    });
    resizeObserver.observe(wrap);

    // ---- Modus-Umschaltung (nur Lampenschirm-Seiten) ----------------------
    // Die Section rendert dort beide Attribut-Sets serverseitig; hier wird nur
    // umgeschaltet. Quelle der Wahrheit ist das gecheckte Radio der Buybox,
    // das Event moonou:mode-change dient als Trigger.
    var modeSets = section.querySelectorAll('.moonou-pd__attrs-set[data-mode]');
    var modeImages = section.querySelectorAll('[data-mode-image]');
    var hasModeMarkup = modeSets.length > 0;

    function currentMode() {
      var checked = document.querySelector('input[name^="moonou_mode-"]:checked');
      // Kein Umschalter im Template -> Komplett-Modus, wie in der Buybox.
      return checked ? checked.value : 'komplett';
    }

    // Aktuelle Variante aus dem DOM: das versteckte id-Feld der Buybox ist die
    // Quelle der Wahrheit, die URL greift nur, solange der Picker noch nicht
    // geschrieben hat (z. B. Direkteinstieg ueber ?variant=).
    function currentVariantId() {
      var input = document.querySelector(
        '.moonou-product form[action*="/cart/add"] input[name="id"]'
      );
      if (input && input.value) return String(input.value);

      var match = window.location.search.match(/[?&]variant=(\d+)/);
      if (match) return match[1];

      return '';
    }

    function applyMode(mode, variantId) {
      if (mode !== 'schirm' && mode !== 'komplett') {
        console.warn('[pd-mode] Unbekannter Modus "' + mode + '", nutze "komplett".');
        mode = 'komplett';
      }

      var vid = variantId ? String(variantId) : currentVariantId();

      modeSets.forEach(function (set) {
        set.hidden = set.getAttribute('data-mode') !== mode;
      });

      // Bild: kein hidden. Das Schirm-Bild bleibt im Fluss und haelt die Hoehe
      // der Media-Spalte, die Komplett-Bilder sind Overlays (siehe CSS).
      // Sichtbar ist genau ein Overlay: passender Modus UND passende Variante.
      var matched = false;
      modeImages.forEach(function (img) {
        var imgVariant = img.getAttribute('data-variant-id');
        var active = img.getAttribute('data-mode-image') === mode;
        if (active && imgVariant) {
          active = imgVariant === vid;
        }
        if (active) matched = true;
        img.setAttribute('data-active', active ? 'true' : 'false');
        if (active) {
          img.removeAttribute('aria-hidden');
        } else {
          img.setAttribute('aria-hidden', 'true');
        }
      });

      // Kein Treffer trotz passendem Modus (z. B. Variante aus dem DOM nicht
      // lesbar) -> lieber das erste Overlay des Modus zeigen als gar keins.
      if (!matched && modeImages.length > 0) {
        var fallback = null;
        modeImages.forEach(function (img) {
          if (!fallback && img.getAttribute('data-mode-image') === mode) {
            fallback = img;
          }
        });
        if (fallback) {
          console.warn('[pd-mode] Kein Overlay fuer Variante "' + vid + '", nutze das erste.');
          fallback.setAttribute('data-active', 'true');
          fallback.removeAttribute('aria-hidden');
        }
      }

      // Der Tabwechsel animiert panelsEl.style.height. Ein stehengebliebener
      // Pixelwert waere nach dem Moduswechsel falsch -> defensiv zuruecksetzen.
      if (panelsEl) {
        panelsEl.style.height = '';
      } else {
        console.warn('[pd-mode] .moonou-pd__panels nicht gefunden.');
      }
    }

    // Alten Listener abraeumen: shopify:section:load ersetzt bei jedem Editor-Reload
    // das komplette Section-Element, daher ist section._moonouPdModeHandler hier immer
    // leer und ein section-gebundener Guard greift nicht. Deshalb ueber den
    // modul-globalen Slot abraeumen (siehe moonouPdModeHandler oben).
    if (moonouPdModeHandler) {
      document.removeEventListener('moonou:mode-change', moonouPdModeHandler);
      moonouPdModeHandler = null;
    }

    if (hasModeMarkup) {
      if (modeImages.length === 0) {
        console.warn('[pd-mode] Attribut-Sets vorhanden, aber kein Komplett-Bild.');
      }
      // Nicht auf das Event warten - der DOM-Zustand gilt sofort.
      applyMode(currentMode());

      moonouPdModeHandler = function (event) {
        var detail = event.detail || {};
        applyMode(detail.mode || currentMode(), detail.variantId);
      };
      document.addEventListener('moonou:mode-change', moonouPdModeHandler);
      section._moonouPdModeHandler = moonouPdModeHandler;
    }

    // Store cleanup reference
    section._moonouPdCleanup = function () {
      resizeObserver.disconnect();
      scrollEl.removeEventListener('scroll', updateFades);
      if (section._moonouPdModeHandler) {
        document.removeEventListener('moonou:mode-change', section._moonouPdModeHandler);
        if (moonouPdModeHandler === section._moonouPdModeHandler) {
          moonouPdModeHandler = null;
        }
        section._moonouPdModeHandler = null;
      }
    };
  }

  function initAll() {
    var sections = document.querySelectorAll('.moonou-pd');
    sections.forEach(function (section) {
      if (section._moonouPdCleanup) {
        section._moonouPdCleanup();
      }
      initSection(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-initialize on section load/select
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.moonou-pd');
    if (section) {
      initSection(section);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.moonou-pd');
    if (!section) return;
    var pill = section.querySelector('.moonou-pd__pill[data-tab-index="' + e.target.dataset.blockIndex + '"]');
    if (pill) {
      pill.click();
    }
  });
})();
